module.exports = __webpack_public_path__ + "static/assets/ab0f8ec0bb72bc97b3d23e4e07396f2c.svg";